"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
/**
 * Returns formatted discount data. eg. all discount, online discount
 * @param discountObj {DiscountType}
 * @param currency {string}
 * @returns {DiscountFactoryType}
 */
function discountFactory(discountObj, currency) {
    const hasDiscount = !!Number((0, get_1.default)(discountObj, 'discount', ''));
    return {
        finalPrice: (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'finalPrice'), currency),
        hasDiscount,
        discount: (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'discount'), currency),
        rental: (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'rentalSum'), currency),
        vat: (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'vat'), currency),
    };
}
exports.default = discountFactory;
